const hours = [
  { day: '火', open: true },
  { day: '水', open: true },
  { day: '木', open: false },
  { day: '金', open: true },
  { day: '土', open: true },
  { day: '月', open: false },
];

export default function ShopInfo() {
  return (
    <section id="access" className="bg-kiln py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-white/10 text-white/70 text-xs font-rounded font-bold tracking-widest px-3 py-1.5 rounded-full mb-4">
            / ACCESS
          </span>
          <h2 className="text-3xl md:text-4xl font-rounded font-black text-white">
            ふぅばてぇへのアクセス
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          {/* Left: shop photo + info */}
          <div className="flex flex-col gap-6">
            <div className="w-full h-64 rounded-2xl overflow-hidden">
              <img
                src="https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/f12da74e81e8af5565ac7eb5ee6c5b2a.webp"
                alt="ふぅばてぇ外観"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Info cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                { icon: 'ri-map-pin-2-line', label: '住所', value: '〒894-3301\n鹿児島県大島郡宇検村湯湾字大畑1869-4' },
                { icon: 'ri-phone-line', label: '電話（予約可）', value: '0997-69-4091', isPhone: true },
                { icon: 'ri-time-line', label: '営業時間', value: '10:00〜18:00' },
                { icon: 'ri-car-line', label: '駐車場', value: 'あり\n奄美空港から車で約1時間30分' },
              ].map((info) => (
                <div key={info.label} className="bg-white/10 rounded-xl p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-7 h-7 flex items-center justify-center">
                      <i className={`${info.icon} text-tankan-light text-lg`} />
                    </div>
                    <span className="text-white/70 text-xs font-rounded">{info.label}</span>
                  </div>
                  {info.isPhone ? (
                    <a href="tel:0997-69-4091" className="text-white font-rounded font-bold text-lg cursor-pointer hover:text-tankan-light transition-colors whitespace-nowrap">
                      {info.value}
                    </a>
                  ) : (
                    <p className="text-white font-rounded font-medium text-sm whitespace-pre-line">{info.value}</p>
                  )}
                </div>
              ))}
            </div>

            {/* Weekly hours */}
            <div className="bg-white/10 rounded-xl p-5">
              <p className="text-white/70 text-xs font-rounded mb-3 tracking-widest">OPEN DAYS</p>
              <div className="flex gap-2">
                {hours.map((h) => (
                  <div key={h.day} className="flex-1 text-center">
                    <p className="text-white/60 text-xs font-rounded mb-1">{h.day}</p>
                    <div
                      className={`h-1.5 rounded-full ${h.open ? 'bg-tankan' : 'bg-white/20'}`}
                    />
                  </div>
                ))}
              </div>
              <div className="mt-3 space-y-1">
                <p className="text-white/80 text-xs font-rounded">営業日：火・水・金・土</p>
                <p className="text-white/80 text-xs font-rounded">定休日：月・木</p>
                <p className="text-white/60 text-xs font-rounded">※日曜日は不定休。お電話またはInstagramでご確認ください。</p>
                <p className="text-white/60 text-xs font-rounded">※たんかん収穫シーズン（1〜2月頃）は休業あり。</p>
              </div>
            </div>
          </div>

          {/* Right: Map */}
          <div className="flex flex-col gap-6">
            <div className="w-full h-96 rounded-2xl overflow-hidden">
              <iframe
                title="ふうばて地図"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3565.7!2d129.3053!3d28.2858!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2z5YuV5bSU5p2x5qCh5aSn5a2m!5e0!3m2!1sja!2sjp!4v1700000000000!5m2!1sja!2sjp"
                className="w-full h-full border-0"
                loading="lazy"
                allowFullScreen
              />
            </div>

            <div className="bg-white/10 rounded-xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-base" />
                  ))}
                </div>
                <span className="text-white font-rounded font-black text-2xl">4.8</span>
                <span className="text-white/60 font-rounded text-sm">/ Google レビュー</span>
              </div>
              <p className="text-white/85 font-rounded text-sm leading-relaxed">
                「宇検村に来たらここ」「また来たい！」と好評いただいています。
                最新のご感想はGoogleマップまたはInstagramでご確認ください。
              </p>
              <div className="mt-4 flex gap-3">
                <a
                  href="https://www.instagram.com/nakamura0v0kensetsu.ukenson/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white font-rounded font-bold text-sm px-4 py-2 rounded-full cursor-pointer transition-colors whitespace-nowrap"
                >
                  <i className="ri-instagram-line" />
                  Instagram
                </a>
                <a
                  href="https://maps.google.com/?q=ふうばて+宇検村"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 bg-tankan hover:bg-tankan-dark text-white font-rounded font-bold text-sm px-4 py-2 rounded-full cursor-pointer transition-colors whitespace-nowrap"
                >
                  <i className="ri-map-2-line" />
                  Googleマップで開く
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
